import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { switchMap, map } from 'rxjs/operators';
import { IBasicAuthUserBackendTokenPayload } from './shared/constants/dfte-user-info';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private tokenExpirationSubject = new BehaviorSubject<boolean>(false);
  tokenExpiration$ = this.tokenExpirationSubject.asObservable();

  constructor(private router: Router) {
    this.startTokenCheck();
  }

  startTokenCheck() {
    interval(3000) 
      .pipe(
        switchMap(() => this.checkTokenExpiration())
      )
      .subscribe((isExpired) => {
        this.tokenExpirationSubject.next(isExpired);
      });
  }

  checkTokenExpiration(): Observable<boolean> {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        const decodedToken: IBasicAuthUserBackendTokenPayload = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        const tokenExpiryTime = decodedToken.exp;

        return of(tokenExpiryTime <= currentTime);
      } catch (error) {
        console.error('Error decoding token:', error);
        return of(true);
      }
    } else {
      return of(true);
    }
  }
}
